import { render, staticRenderFns } from "./FichaC.vue?vue&type=template&id=125ca5e0&scoped=true&"
import script from "./FichaC.vue?vue&type=script&lang=js&"
export * from "./FichaC.vue?vue&type=script&lang=js&"
import style0 from "./FichaC.vue?vue&type=style&index=0&id=125ca5e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125ca5e0",
  null
  
)

export default component.exports